import { render, staticRenderFns } from "./questionSettingTemplate.vue?vue&type=template&id=7f736d92&scoped=true"
import script from "./questionSettingTemplate.vue?vue&type=script&lang=ts"
export * from "./questionSettingTemplate.vue?vue&type=script&lang=ts"
import style0 from "./questionSettingTemplate.vue?vue&type=style&index=0&id=7f736d92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f736d92",
  null
  
)

export default component.exports